<template>
	<div class="row">
		<div class="col-sm-12 well well-lg">
			<h4 class="text-center">{{ ( isAuditStep ? "Critère " : "Question ") + currentPosition }}/{{ criteriaQuestionTotalNumber }}{{ isCriticStep ? " (Résultat: " + currentCriteriaPercentageOfYes + "% de Oui)" : "" }}</h4>
			<span v-if="isAuditStep" v-html="currentCriteriaQuestionText"></span>
			<span v-else v-html="currentCriteriaQuestionText.label"></span>
		</div>
	</div>
</template>

<script>
	export default {
		computed: {
			isCriticStep: function()	{
				return this.$store.state.user.currentStep == "CRITIC_STEP";
			},
			isAuditStep: function()	{
				return this.$store.state.user.currentStep != "SATISFACTION_SURVEY";
			},
			currentPosition: function()	{
				return this.$store.state.user.currentPosition;
			},
			criteriaQuestionTotalNumber: function()	{
				return this.$store.getters.criteriaQuestionTotalNumber;
			},
			currentCriteriaQuestionText: function()	{
				return this.$store.getters.currentCriteriaQuestionText;
			}
		},
        props: ['currentCriteriaPercentageOfYes']
	};
</script>
